<select
  [id]="id"
  [ngModel]="value()"
  (ngModelChange)="onSelectChange($event)"
  [disabled]="disabled"
>
  <option value="">{{ placeholder }}</option>
  @for (s of usStates; track s.code) {
    <option [value]="s.code" [title]="s.name">{{ codesOnly ? s.code : s.code + ' – ' + s.name }}</option>
  }
</select>
